import { styled } from '@mui/material/styles';

const StyledSvg = styled('svg')({
    width: 64,
    height: 72,
});

export default StyledSvg;
